// userSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  firstName: '',
  lastName: '',
  contact: '',
  role: '',
  studentId: '',
  token: '',
  email: '',
  enquiryId: '',
  enquiryPersonalDetailId:'',
  userId: ''
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
        const { first_name, last_name, mobile, user_role, student_id, token, email, enquiry_id,enquiry_personal_detail_id, user_id } = action.payload;
        state.firstName = first_name;
        state.lastName = last_name;
        state.contact = mobile;
        state.email = email;
        state.role = user_role;
        state.studentId = student_id;
        state.token = token;
        state.enquiryId = enquiry_id;
        state.enquiryPersonalDetailId=enquiry_personal_detail_id
        state.userId = user_id

        localStorage.setItem('studentId', student_id);
        localStorage.setItem('enquiryId', enquiry_id);
        localStorage.setItem('userId', user_id);
        localStorage.setItem('enquiryPersonalDetailId', enquiry_personal_detail_id);
    },
    clearUserData: (state) => {
        state.firstName = '';
        state.lastName = '';
        state.contact = '';
        state.role = '';
        state.studentId = '';
        state.token = '';
        state.email = '';
        state.enquiryId = '';
        state.enquiryPersonalDetailId=''
        state.userId = '';

        localStorage.removeItem('studentId');
        localStorage.removeItem('enquiryId');
        localStorage.removeItem('enquiryPersonalDetailId');

        localStorage.clear();
      },
  },
});

export const { setUser, clearUserData } = userSlice.actions;

export default userSlice.reducer;
